import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Link from 'components/consumer/Link';
import Placeholder from 'components/consumer/Placeholder';

const FlatButton = React.forwardRef(
  (
    {
      children,
      color,
      isSelected = false,
      isSelectedButtonFilled = false,
      loading = false,
      onClick,
      onMouseEnter,
      onMouseLeave,
      scrollOnMobile = false,
      spacer = false,
      to,
    },
    ref
  ) => {
    if (spacer) {
      return (
        <div
          className={classNames(
            'text-xs font-bold bg-transparent border border-solid border-gray-light6 rounded text-gray inline-block p-1.5 no-underline transition-[all_75ms_ease] hover:border hover:border-solid hover:border-gray-light2 hover:text-gray hover:cursor-pointer hover:max-[767px]:cursor-auto',
            {
              'max-[767px]:border-0 max-[767px]:m-0 max-[767px]:px-[7px] max-[767px]:py-0 max-[767px]:min-h-[35px] max-[767px]:invisible md:hidden': scrollOnMobile,
            }
          )}
        />
      );
    }

    if (loading) {
      return (
        <Placeholder
          type="rect"
          loading
          className="text-xs font-bold bg-transparent rounded text-gray inline-block p-1.5 no-underline transition-[all_75ms_ease] hover:text-gray min-h-[35px] max-w-[65px] border border-solid border-gray-light8 hover:border hover:border-solid hover:border-gray-light8 hover:cursor-default"
        />
      );
    }

    const classes = classNames(
      'text-xs font-bold bg-transparent border border-solid border-gray-light6 rounded text-gray inline-block p-1.5 no-underline [transition:all_75ms_ease]',
      'hover:border hover:border-solid hover:border-gray-light2 hover:text-gray hover:cursor-pointer',
      {
        '!text-gray !border-brand-dark !hover:border !hover:border-solid !hover:border-brand-darker !hover:text-gray-dark': isSelected,
        '!bg-[#107C8C] !text-white': isSelected && isSelectedButtonFilled,
        '!bg-white': isSelected && !isSelectedButtonFilled,
        'max-[767px]:whitespace-nowrap': scrollOnMobile,
        '!text-red hover:!text-red hover:!border-[#832829] !bg-[#F7F1F2]':
          color === 'red',
      }
    );

    if (to) {
      return (
        <Link
          className={classes}
          onClick={onClick}
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
          to={to}
          ref={ref}
        >
          {children}
        </Link>
      );
    }

    return (
      <button
        className={classes}
        onClick={onClick}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        type="button"
        ref={ref}
      >
        {children}
      </button>
    );
  }
);

FlatButton.propTypes = {
  children: PropTypes.node,
  color: PropTypes.oneOf(['red']),
  isSelected: PropTypes.bool,
  loading: PropTypes.bool,
  onClick: PropTypes.func,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
  scrollOnMobile: PropTypes.bool,
  spacer: PropTypes.bool,
  isSelectedButtonFilled: PropTypes.bool,
  to: PropTypes.string,
};

export default FlatButton;
